export default "__VITE_ASSET__Dzs4kVVM__"